// Angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { DxWidgetUtils, Utils } from 'cc-common';
import { DxPopupComponent } from 'devextreme-angular';

// Component imports
import { BoardApprovalBaseComponent } from '../../_base/board-approval-base.component';

// constant imports
import { BoardApprovalProcessConstants } from '../../../shared-acc-board-approval-module/_constants/board-approval-process-constants';

// model imports
import { BoardApprovalParameterDto } from '../../../shared-acc-board-approval-module/_models/board-approval-parameter-dto';
import { BoardApprovalQueueParameterDto } from '../../../shared-acc-board-approval-module/_models/board-approval-queue-parameter-dto';
import { BoardApprovalsActionParametersDto } from '../../../shared-acc-board-approval-module/_models/board-approvals-action-parameters-dto';
import { BoardApprovalActionsResultDto } from '../../../shared-acc-board-approval-module/_models/board-approval-actions-result-dto';

@Component({
    selector: 'app-muliple-board-approval-editor',
    templateUrl: './muliple-board-approval-editor.component.html',
    styleUrls: ['./muliple-board-approval-editor.component.scss']
})
export class MulipleBoardApprovalEditorComponent extends BoardApprovalBaseComponent implements OnInit {
    @ViewChild('multipleBoardApprovalEditor', { static: false }) multipleBoardApprovalEditor: DxPopupComponent;

    @Input() recordsToProcess: BoardApprovalParameterDto[] = [];
    @Input() visible = false;
    @Input() queueParams: BoardApprovalQueueParameterDto;
    @Input() actionTitle: string;
    @Input() process: string;
    @Input() multipleBoardApprovalAction: BoardApprovalActionsResultDto;

    @Output() onClose = new EventEmitter<boolean>();

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        this.selectedProcess = this.process;
    }

    onPopupShown(): void {
        DxWidgetUtils.instantRepaint(this.multipleBoardApprovalEditor);
    }

    onPopupHidden(): void {
        this.recordsToProcess = [];
        this.visible = false;
        this.onClose.emit(false);
    }

    onCancelClick(): void {
        this.onPopupHidden();
    }

    onSaveClick(): void {
        const params: BoardApprovalsActionParametersDto = new BoardApprovalsActionParametersDto();
        params.isClosed = Utils.isTrue(this.queueParams.isClosedQueue);
        params.communityId = this.queueParams.communityId;
        params.boardApprovalData = this.recordsToProcess;

        switch (this.process) {
            case BoardApprovalProcessConstants.ACC:
                this.saveAccAprrovals(this.multipleBoardApprovalAction.actionCode, params);
                break;
            case BoardApprovalProcessConstants.COLLECTIONS:
                this.saveCollectionApprovals(this.multipleBoardApprovalAction.actionCode, params);
                break;
            case BoardApprovalProcessConstants.WF:
                this.saveWFApprovals(this.multipleBoardApprovalAction.actionCode, params);
                break;
        }
    }

    getProcessIdGroupTemplateTitle(data: any): string {
        let groupTitleText: string = null;
        if (Utils.notNullAndDefined(data)) {
            if (Utils.notNullOrEmpty(data.items)) {
                groupTitleText = `ID: ${data.items[0].processIdDisplayText}: ${data.items[0].description}`;
            } else if (Utils.notNullOrEmpty(data.collapsedItems)) {
                groupTitleText = `ID: ${data.collapsedItems[0].processIdDisplayText}: ${data.collapsedItems[0].description}`;
            }
        }

        return groupTitleText;
    }
}
